<template>
  <div class="report-export-buttons d-inline-flex gap-1 flex-wrap">
    <icon-button
      :func="() => download('csv')"
      :icon="'file-excel'"
      :title="'Export CSV'"
      :classes="'akkurate-gray-btn btn-size2'"
      :btnName="'CSV'"
      :disabled="disabled || exporting"
    />
    <icon-button
      :func="() => download('xlsx')"
      :icon="'file-excel'"
      :title="'Export Excel'"
      :classes="'akkurate-gray-btn btn-size2'"
      :btnName="'Excel'"
      :disabled="disabled || exporting"
    />
    <icon-button
      :func="() => download('pdf')"
      :icon="'file-pdf'"
      :title="'Export PDF'"
      :classes="'akkurate-gray-btn btn-size2'"
      :btnName="'PDF'"
      :disabled="disabled || exporting"
    />
    <icon-button
      :func="() => download('html', true)"
      :icon="'print'"
      :title="'Print'"
      :classes="'akkurate-gray-btn btn-size2'"
      :btnName="'Print'"
      :disabled="disabled || exporting"
    />
  </div>
</template>

<script>
import Vue from "vue";
import IconButton from "@/components/IconButton.vue";

export default {
  name: "ReportExportButtons",
  components: {
    IconButton,
  },
  props: {
    reportKey: { type: String, required: true },
    params: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { exporting: false };
  },
  methods: {
    async download(format, openInNewTab = false) {
      this.exporting = true;
      const mime = {
        csv: "text/csv",
        html: "text/html",
        pdf: "application/pdf",
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      };
      const ext = { csv: "csv", html: "html", pdf: "pdf", xlsx: "xlsx" };
      try {
        const response = await Vue.axios.get("reports/export", {
          params: { report: this.reportKey, format, ...this.params },
          responseType: "blob",
          headers: { Accept: mime[format] || "application/octet-stream" },
        });
        const blob = new Blob([response.data], {
          type: mime[format] || "application/octet-stream",
        });
        const url = window.URL.createObjectURL(blob);
        if (openInNewTab) {
          window.open(url, "_blank");
        } else {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${this.reportKey}.${ext[format] || format}`,
          );
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
        setTimeout(() => window.URL.revokeObjectURL(url), 5000);
      } catch (err) {
        const message = err?.response?.data?.message || "Export failed";
        this.$bvToast?.toast(message, { variant: "danger", solid: true });
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>
